import 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.css'
import 'lg-thumbnail.js'

var galleries = document.querySelectorAll('.lightgallery')
if (galleries) {
  Array.prototype.forEach.call(galleries, function (gallery) {
    lightGallery(gallery, {
      thumbnail: true,
      toggleThumb: false,
      counter: false,
      download: false,
      hideBarsDelay: 9237932789327892378920
    })
  })
}